// TODO: refactor — replace VideoPreviewModal with a new TS modal component
import VideoPreviewModal from '@/components/VideoPreviewModal/VideoPreviewModal'

import { ANNOUNCEMENTS_TUTORIAL_VIDEO_URL } from './video-tutorial-modal.constants'

interface AnnouncementsVideoTutorialModalProps {
  onClose: VoidFunction
}

export const AnnouncementsVideoTutorialModal = ({
  onClose,
}: AnnouncementsVideoTutorialModalProps) => {
  return (
    <VideoPreviewModal handleCloseVideo={onClose} videoUrl={ANNOUNCEMENTS_TUTORIAL_VIDEO_URL} />
  )
}
